type UiNodeSelectionSlice = {
  selectedNativeIdPath: Array<unknown>;
  selectionSet: {size: number};
};

/**
 * Returns true when node selection transitions from inactive → active.
 * Used by both MCC and Component Canvas to enforce mutual exclusivity
 * between frame selection and element selection.
 */
export const didSelectionStart = (
  prev: UiNodeSelectionSlice,
  next: UiNodeSelectionSlice
): boolean => {
  const wasActive =
    prev.selectedNativeIdPath.length > 0 || prev.selectionSet.size > 0;
  const isActive =
    next.selectedNativeIdPath.length > 0 || next.selectionSet.size > 0;
  return !wasActive && isActive;
};

const MIN_MAX_FRAME_HEIGHT = {
  minHeight: 0,
  maxHeight: 10000,
} as const;

/**
 * Returns the minimum and maximum height for frames.
 */
export const getMinMaxFrameHeight = () => {
  return MIN_MAX_FRAME_HEIGHT;
};
